import { useCallback } from 'react';
import { useRouter } from 'expo-router';

import { useTelemetry } from '@order/Telemetry';

export const useHomeNavigation = (orderId: string | null = null) => {
  const { track } = useTelemetry();
  const router = useRouter();

  // ─── Navigation ──────────────────────────────────────────────────────

  const navigateToAccount = useCallback(() => {
    track('home.account.cta_tapped');

    router.navigate('/account');

    if (router.canDismiss()) {
      router.dismissAll(); // reset account stack to start from the initial route
    }
  }, [router, track]);

  const navigateToLoyalty = useCallback(() => {
    track('home.loyalty.cta_tapped');

    router.navigate('/rewards');
  }, [router, track]);

  const navigateToSignIn = useCallback(() => {
    track('home.banner.cta_tapped', { destination: 'SignIn' });

    router.navigate({
      pathname: '/(auth)/join-or-sign-in',
      params: { redirect: '/' },
    });
  }, [router, track]);

  const navigateToOrderStatus = useCallback(() => {
    if (!orderId) return;

    track('home.banner.cta_tapped', { destination: 'OrderStatus' });

    router.navigate({
      pathname: '/order-status/[orderId]',
      params: { orderId },
    });
  }, [orderId, router, track]);

  const navigateToRateOrder = useCallback(() => {
    if (!orderId) return;
    track('home.banner.cta_tapped', { destination: 'RateOrder' });

    router.navigate({
      pathname: '/feedback/[orderId]',
      params: { orderId },
    });
  }, [orderId, router, track]);

  return {
    navigateToAccount,
    navigateToLoyalty,
    navigateToSignIn,
    navigateToOrderStatus,
    navigateToRateOrder,
  };
};
